import { render, staticRenderFns } from "./invitation-detail.vue?vue&type=template&id=4661bb7d&scoped=true&lang=html&"
import script from "./invitation-detail.vue?vue&type=script&lang=js&"
export * from "./invitation-detail.vue?vue&type=script&lang=js&"
import style0 from "./invitation-detail.vue?vue&type=style&index=0&id=4661bb7d&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4661bb7d",
  null
  
)

export default component.exports